define('TescoMobile_Checkout/js/action/set-monthly-payment',['mage/storage', 'Magento_Checkout/js/model/url-builder', 'Magento_Checkout/js/model/quote', 'Magento_Checkout/js/model/error-processor', 'Magento_Checkout/js/model/full-screen-loader', 'Magento_Customer/js/model/customer'], function (storage, urlBuilder, quote, errorProcessor, fullScreenLoader, customer) {
  'use strict';

  return function (messageContainer, data) {
    let serviceUrl;
    if (customer.isLoggedIn()) {
      serviceUrl = urlBuilder.createUrl('/carts/mine/set-monthly-payment', {});
    } else {
      serviceUrl = urlBuilder.createUrl('/guest-carts/:cartId/set-monthly-payment', {
        cartId: quote.getQuoteId()
      });
    }
    const payload = {
      cartId: quote.getQuoteId(),
      monthlyPayment: data
    };
    fullScreenLoader.startLoader();
    return storage.post(serviceUrl, JSON.stringify(payload)).fail(function (response) {
      errorProcessor.process(response, messageContainer);
    }).always(function () {
      fullScreenLoader.stopLoader();
    });
  };
});

